import { Component, Input, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { showDemo } from './util';

@Component({
  selector: 'app-title-header',
  template: `
    @if ((hideTitleText$ | async) !== true) { @if (rescheduling) {
    <h1 data-testid="title" i18n="@@CALENDAR.RESCHEDULE_A_MEETING">
      Reschedule a meeting
    </h1>
    } @if (!rescheduling) { @if (demo) {
    <h1 data-testid="title" i18n="@@CONTACT_FORM.SCHEDULE_A_DEMO">
      Schedule a demo
    </h1>
    } @else {
    <h1 data-testid="title" i18n="@@CONTACT_FORM.SCHEDULE_A_MEETING">
      Schedule a meeting
    </h1>
    } } }
  `,
  standalone: false,
})
export class TitleHeaderComponent implements OnInit {
  @Input() rescheduling = false;
  hideTitleText$: Observable<boolean>;
  demo = showDemo();

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    this.hideTitleText$ = this.route.queryParams.pipe(
      map((params) => params?.hide_header === 'true')
    );
  }
}
